import React from 'react';
import ContactFormAccordion from './ContactFormAccordion';
const ContactFormAccordionGroup = (props: any) => {
  return (
    <div className="ContactFormAccordionGroup-background">
      <div className="container">
        <ContactFormAccordion data={props.data} history={props.history} />
      </div>
    </div>
  );
};

export default ContactFormAccordionGroup;
